import intl from 'react-intl-universal';
import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';
import { ConfirmModal } from 'shared/modals/confirmModal';
import PropTypes from 'prop-types';
const propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

const ConfirmIssueModal = ({ isOpened, onConfirm }) => {
  return (
    <ConfirmModal
      isOpened={isOpened}
      title={intl.get('confirm_not_check_message_1')}
      bodyText={intl.get('confirm_not_check_message_2')}
      onConfirm={onConfirm}
      confirmButtonText={intl.get('confirm_not_check_message_4')}>
      <MDBox data-testid="modal-child-box" sx={{ maxWidth: 'md' }}>
        <MDTypography variant="h6">
          {intl.get('confirm_not_check_message_3')}
        </MDTypography>
      </MDBox>
    </ConfirmModal>
  );
};

ConfirmIssueModal.propTypes = propTypes;
export default ConfirmIssueModal;
